(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-text-block"] && !Shopify.designMode) return;
  try {
    
// Smooth scroll to PRODUCT IMAGES
document.querySelectorAll('.smooth-scroll-btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    
    // Target the product images container from your theme
    const imageContainer = document.querySelector('.product-media-container') || 
                         document.querySelector('.product__media-wrapper');
    
    if (imageContainer) {
      imageContainer.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start' // Aligns to top of viewport
      });
      
      // Optional: Highlight images with temporary border
      imageContainer.style.boxShadow = '0 0 0 2px #7A5EC5';
      setTimeout(() => imageContainer.style.boxShadow = '', 1000);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
